import { BlogDecorator } from './Decorators/BlogDecorator';
import { BothSidesDecorator } from './Decorators/BothSidesDecorator';
import { DefaultDecorator } from './Decorators/DefaultDecorator';
import { ModestDecorator } from './Decorators/ModestDecorator';
import { SalesDecorator } from './Decorators/SalesDecorator';
import { SalesMartaDecorator } from './Decorators/SalesMartaDecorator';

export const bannerDecorators = {
  default: DefaultDecorator,
  sales: SalesDecorator,
  salesMarta: SalesMartaDecorator,
  blog: BlogDecorator,
  modest: ModestDecorator,
  bothSides: BothSidesDecorator,
};

export type BannerDecorator = keyof typeof bannerDecorators;
